{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Kérjük válassz egy beszélgetést a bal sávból",
    "CSAT_REPLY_MESSAGE": "Kérlek értékeld a beszélgetést",
    "404": "Elnézést, a beszélgetés nem található. Kérlek, próbáld újra",
    "SWITCH_VIEW_LAYOUT": "Elrendezés megváltoztatása",
    "DASHBOARD_APP_TAB_MESSAGES": "Üzenetek",
    "UNVERIFIED_SESSION": "A felhasználó személyazonossága nincs hitelesítve",
    "NO_MESSAGE_1": "Jajj ne! Úgy tűnik, hogy nincs több ügyfélbeszélgetés az inboxodban.",
    "NO_MESSAGE_2": "egy üzenet küldéséhez az oldaladra!",
    "NO_INBOX_1": "Hola! Úgy tűnik, hogy még nem adtál hozzá fiókokat.",
    "NO_INBOX_2": " Első lépések",
    "NO_INBOX_AGENT": "O-Ó! Úgy tűnik, hogy egyetlen fióknak sem vagy tagja. Kérjük lépj kapcsolatba az adminisztrátoroddal",
    "SEARCH_MESSAGES": "Üzenetek keresése a beszélgetésekben",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "menü megnyitása",
      "KEYBOARD_SHORTCUTS": "billentyűparancs megtekintése"
    },
    "SEARCH": {
      "TITLE": "Üzenetekben keresés",
      "RESULT_TITLE": "Keresés eredménye",
      "LOADING_MESSAGE": "Adatelemzés...",
      "PLACEHOLDER": "Írj be szöveget hogy keress az üzenetek közt",
      "NO_MATCHING_RESULTS": "Nincs találat."
    },
    "UNREAD_MESSAGES": "Olvasatlan üzenetek",
    "UNREAD_MESSAGE": "Olvasatlan üzenet",
    "CLICK_HERE": "Kattints ide",
    "LOADING_INBOXES": "Postaládák betöltése",
    "LOADING_CONVERSATIONS": "Beszélgetések betöltése",
    "CANNOT_REPLY": "Nem tudunk válaszolni, mivel",
    "24_HOURS_WINDOW": "24 órás üzeneti ablak megkötés",
    "48_HOURS_WINDOW": "48 órás üzeneti ablak megkötés",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "Ez a beszélgetés nincs hozzádrendelve. Szeretnéd magadhoz rendelni?",
    "ASSIGN_TO_ME": "Hozzárendelés magamhoz",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Erre a beszélgetésre csak konzerv válasszal válaszolhatsz, mert",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 órás üzeneti ablak megkötés",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "REPLYING_TO": "Neki válaszolsz:",
    "REMOVE_SELECTION": "Kijelölés törlése",
    "DOWNLOAD": "Letöltés",
    "UNKNOWN_FILE_TYPE": "Ismeretlen fájl",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} megbeszélést kezdett"
    },
    "UPLOADING_ATTACHMENTS": "Csatolt fileok feltöltése...",
    "REPLIED_TO_STORY": "Válaszolt a storydra",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Ez az üzenet nem támogatott. Ezt az üzenetet a Facebook Messenger alkalmazásban tekintheti meg.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Ez az üzenet nem támogatott. Ezt az üzenetet az Instagram alkalmazásban tekintheti meg.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Üzenet törölve",
    "FAIL_DELETE_MESSSAGE": "Nem tudtad törölni az üzenetet! Próbáld újra",
    "NO_RESPONSE": "Nincs válasz",
    "RESPONSE": "Response",
    "RATING_TITLE": "Értékelés",
    "FEEDBACK_TITLE": "Visszajelzés",
    "REPLY_MESSAGE_NOT_FOUND": "Üzenet nem elérhető",
    "CARD": {
      "SHOW_LABELS": "Cimkék mutatása",
      "HIDE_LABELS": "Cimkék elrejtése",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Kevesebb mutatása"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Megoldva",
      "REOPEN_ACTION": "Újranyitás",
      "OPEN_ACTION": "Megnyitás",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Tovább",
      "CLOSE": "Bezárás",
      "DETAILS": "részletek",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Halasztás eddig",
      "SNOOZED_UNTIL_TOMORROW": "Halasztás holnapig",
      "SNOOZED_UNTIL_NEXT_WEEK": "Halasztás jövő hétig",
      "SNOOZED_UNTIL_NEXT_REPLY": "Halasztás következő válaszig",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Függőben levőként megjelölés",
      "SNOOZE_UNTIL": "Halasztás",
      "SNOOZE": {
        "TITLE": "Halasztás eddig",
        "NEXT_REPLY": "Következő válasz",
        "TOMORROW": "Holnap",
        "NEXT_WEEK": "Jövő héten"
      }
    },
    "MENTION": {
      "AGENTS": "Ügynökök",
      "TEAMS": "Csapatok"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Halasztás eddig",
      "APPLY": "Halasztás",
      "CANCEL": "Mégse"
    },
    "PRIORITY": {
      "TITLE": "Prioritás",
      "OPTIONS": {
        "NONE": "Nincs",
        "URGENT": "Sürgős",
        "HIGH": "Magas",
        "MEDIUM": "Közepes",
        "LOW": "Alacsony"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Nincs",
        "INPUT_PLACEHOLDER": "Prioritás megadása",
        "NO_RESULTS": "Nincs találat",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Nem sikerült megváltoztatni a prioritást. Kérlek, próbáld újra."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Törlés"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Függőben levőként megjelölés",
      "RESOLVED": "Megjelölés megoldottként",
      "MARK_AS_UNREAD": "Megjelölés olvasatlanként",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Beszélgetés újranyitása",
      "SNOOZE": {
        "TITLE": "Halasztás",
        "NEXT_REPLY": "Következő válaszig",
        "TOMORROW": "Holnapig",
        "NEXT_WEEK": "Jövő hétig"
      },
      "ASSIGN_AGENT": "Ügynök hozzárendelése",
      "ASSIGN_LABEL": "Cimke hozzáadása",
      "AGENTS_LOADING": "Ügynökök betöltése...",
      "ASSIGN_TEAM": "Csapat hozzárendelése",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assigned to \"{agentName}\"",
          "FAILED": "Nem sikerült hozzárendelni ügynököt. Kérlek, próbáld újra."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nem sikerült hozzárendelni címkét. Kérlek, próbáld újra."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Assigned team \"{team}\" to conversation id {conversationId}",
          "FAILED": "Nem sikerült hozzárendelni csoporthoz. Kérlek, próbáld újra."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Üzenet aláírás",
      "ENABLE_SIGN_TOOLTIP": "Aláírás bekapcsolása",
      "DISABLE_SIGN_TOOLTIP": "Aláírás kikapcsolása",
      "MSG_INPUT": "Shift + enter új sorért. Kezdj a '/'-el mentett válasz kiválasztásához.",
      "PRIVATE_MSG_INPUT": "Shift + enter új sorért. Ezt csak ügynökök láthatják",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Üzenet aláírása nem változott, kérlek, változtasd meg a profilod beállításaiban. ",
      "COPILOT_MSG_INPUT": "Adj további promptokat a copilothoz, vagy kérdezz bármi mást... Nyomd meg az Entert a folytatáshoz",
      "CLICK_HERE": "Frissítéshez kattints ide",
      "WHATSAPP_TEMPLATES": "Whatsapp sablonok"
    },
    "REPLYBOX": {
      "REPLY": "Válasz",
      "PRIVATE_NOTE": "Privát üzenet",
      "SEND": "Elküldés",
      "CREATE": "Megjegyzés hozzáadása",
      "INSERT_READ_MORE": "Tudj meg többet",
      "DISMISS_REPLY": "Válasz elutasítása",
      "REPLYING_TO": "Válaszolva a következőre:",
      "TIP_EMOJI_ICON": "Emoji választó mutatása",
      "TIP_ATTACH_ICON": "Fileok csatolása",
      "TIP_AUDIORECORDER_ICON": "Hangfelvétel",
      "TIP_AUDIORECORDER_PERMISSION": "Hozzáférés megadása a hangfelvételhez",
      "TIP_AUDIORECORDER_ERROR": "Nem sikerült megnyitni a hangfelvételt",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Helyezd ide a csatolmányt",
      "START_AUDIO_RECORDING": "Hangfelvétel indítása",
      "STOP_AUDIO_RECORDING": "Hangfelvétel leállítása",
      "COPILOT_THINKING": "Copilot gondolkodik",
      "EMAIL_HEAD": {
        "TO": "Címzett",
        "ADD_BCC": "Titkos másolat hozzáadása",
        "CC": {
          "LABEL": "Másolat",
          "PLACEHOLDER": "E-mail vesszőkkel elválasztva",
          "ERROR": "Kérlek, adj meg érvényes e-mail címet"
        },
        "BCC": {
          "LABEL": "Titkos másolat",
          "PLACEHOLDER": "E-mail vesszőkkel elválasztva",
          "ERROR": "Kérlek, adj meg érvényes e-mail címet"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Definiálatlan változók",
        "MESSAGE": "Az üzeneted {undefinedVariablesCount} definiálatlan változót tartalmaz: {undefinedVariables}. Így is el szeretnéd küldeni az üzenetet?",
        "CONFIRM": {
          "YES": "Elküldés",
          "CANCEL": "Mégse"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Privát megjegyzés: csak Neked és a csapat tagjainak látható",
    "CHANGE_STATUS": "A beszélgetés státusza megváltozott",
    "CHANGE_STATUS_FAILED": "A beszélgetés státuszának megváltoztatása sikertelen",
    "CHANGE_AGENT": "Hozzárendelt ügynök megváltoztatva",
    "CHANGE_AGENT_FAILED": "Felelős megváltoztatása sikertelen",
    "ASSIGN_LABEL_SUCCESFUL": "Címke sikeresen hozzárendelve",
    "ASSIGN_LABEL_FAILED": "Címke hozzárendelése sikertelen",
    "CHANGE_TEAM": "A beszélgetés csapata megváltozott",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "A file mérete meghaladja a {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} limitet",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Nem tudsz üzenetet küldeni, kérlek, próbáld újra",
    "SENT_BY": "Küldő:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Nem sikerült elküldeni az üzenetet! Próbáld újra.",
    "TRY_AGAIN": "újra",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Ügynök kiválasztása",
      "REMOVE": "Eltávolítás",
      "ASSIGN": "Hozzárendelés"
    },
    "CONTEXT_MENU": {
      "COPY": "Másolás",
      "REPLY_TO": "Válasz az üzenetre",
      "DELETE": "Törlés",
      "CREATE_A_CANNED_RESPONSE": "Mentett válasz hozzáadása",
      "TRANSLATE": "Fordítás",
      "COPY_PERMALINK": "Link másolása az üzenetbe",
      "LINK_COPIED": "Üzenet URL címe másolva lett a vágólapra",
      "DELETE_CONFIRMATION": {
        "TITLE": "Biztosan törölni szeretnéd ezt az üzenetet?",
        "MESSAGE": "Nem tudod visszavonni ezt a műveletet",
        "DELETE": "Törlés",
        "CANCEL": "Mégse"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Elutasítás",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Beszélgetés kivonat elküldése",
    "DESC": "A beszélgetés másolatának elküldése egy megadott e-mailcímre",
    "SUBMIT": "Elküldés",
    "CANCEL": "Mégse",
    "SEND_EMAIL_SUCCESS": "A beszélgetés jegyzet sikeresen elküldve",
    "SEND_EMAIL_ERROR": "Hiba történt, kérjük próbáld újra",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "A beszélgetés jegyzet elküldése az ügyfélnek",
      "SEND_TO_AGENT": "A beszélgetés jegyzet elküldése a hozzárendelt ügynöknek",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Küldj jegyzetet egy másik e-mailcímre",
      "EMAIL": {
        "PLACEHOLDER": "E-mailcím megadása",
        "ERROR": "Kérjük helyes e-mailcímet adj meg"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hello 👋, köszöntünk a {installationName}!",
    "DESCRIPTION": "Köszönjük, hogy feliratkoztál. Segíteni akarunk, hogy a legtöbbet hozd ki a {installationName}. Itt találsz egy pár dolgot, amit a {installationName} lehetővé tesz.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Olvasd el legfrissebbeket",
    "ALL_CONVERSATION": {
      "TITLE": "Minden beszélgetésed egy helyen",
      "DESCRIPTION": "Kövesd az összes ügyfélbeszélgetésedet egy felületről. Szűrheted a beszélgetéseket csatorna, cimke vagy státusz alapján.",
      "NEW_LINK": "Kattints ide postaláda létrehozásához"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Hívd meg csapattagjaidat",
      "DESCRIPTION": "Mivel éppen ügyféllel készülsz beszélni, hívd meg a csapattagjaidat, hogy segíthessenek neked. Az e-mailcímük ügynöklistába való megadásával tudod meghívni őket.",
      "NEW_LINK": "Kattints ide csapattag meghívásához"
    },
    "LABELS": {
      "TITLE": "Rendezd a beszélgetéseket cimkékkel",
      "DESCRIPTION": "A cimkék egyszerű módot biztosítanak hogy kategorizáld a beszélgetést. Hozz létre cimkéket, mint például a #támogatás vagy a #számlázás, stb... későbbi használatra.",
      "NEW_LINK": "Kattints ide cimkék létrehozásához"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Hozzárendelt ügynök",
    "SELF_ASSIGN": "Hozzárendelés magamhoz",
    "TEAM_LABEL": "Hozzárendelt csapat",
    "SELECT": {
      "PLACEHOLDER": "Nincs"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Kontakt adatai",
      "CONVERSATION_ACTIONS": "Beszélgetés Műveletek",
      "CONVERSATION_LABELS": "Beszélgetés cimkék",
      "CONVERSATION_INFO": "Beszélgetés Információk",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Kontakt Tulajdonságok",
      "PREVIOUS_CONVERSATION": "Korábbi beszélgetések",
      "MACROS": "Makrók",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "Összes megtekintése",
      "SHOW_LESS": "Kevesebb mutatása",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Függőben lévő",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Attribútum hozzáadása",
    "NO_RECORDS_FOUND": "Nem található tulajdonság",
    "UPDATE": {
      "SUCCESS": "Tulajdonság sikeresen frissítve",
      "ERROR": "Nem lehet frissíteni a tulajdonságot. Kérlek, próbáld újra"
    },
    "ADD": {
      "TITLE": "Hozzáadás",
      "SUCCESS": "Tulajdonság sikeresen hozzáadva",
      "ERROR": "Nem lehet hozzáadni a tulajdonságot. Kérlek, próbáld újra"
    },
    "DELETE": {
      "SUCCESS": "Tulajdonság sikeresen törölve",
      "ERROR": "Nem lehet törölni a tulajdonságot. Kérlek, próbáld újra"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Attribútum hozzáadása",
      "PLACEHOLDER": "Attribútumok keresése",
      "NO_RESULT": "Nem található attribútum"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Innen",
    "TO": "Ide",
    "BCC": "Titkos másolat",
    "CC": "Másolat",
    "SUBJECT": "Tárgy",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Részvétel",
    "SIDEBAR_TITLE": "Résztvevők",
    "NO_RECORDS_FOUND": "Nincs találat",
    "ADD_PARTICIPANTS": "Résztvevők kiválasztása",
    "REMANING_PARTICIPANTS_TEXT": "+{count} fő",
    "REMANING_PARTICIPANT_TEXT": "+{count} fő",
    "TOTAL_PARTICIPANTS_TEXT": "+{count} fő vesz részt.",
    "TOTAL_PARTICIPANT_TEXT": "+{count} fő vesz részt.",
    "NO_PARTICIPANTS_TEXT": "Nincs részvevő!.",
    "WATCH_CONVERSATION": "Csatlakozás a beszélgetéshez",
    "YOU_ARE_WATCHING": "Te részt veszel",
    "API": {
      "ERROR_MESSAGE": "Nem sikerült frissítenbi, próbálja újra később!",
      "SUCCESS_MESSAGE": "Résztvevők frissítve!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Fordított szöveg megtekintése",
    "DESC": "Meg tudod nézni a fordított tartalmat minden nyelven.",
    "ORIGINAL_CONTENT": "Eredeti szöveg",
    "TRANSLATED_CONTENT": "Fordított szöveg",
    "NO_TRANSLATIONS_AVAILABLE": "Nem elérhető fordítás ehhez a tartalomhoz"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
